export default class QuestionLibraryAPI {

    constructor(http) {
        this.http = http
    }

    getAvailableQuestions = (explori, productType, respondentType, category, oid) => {
        return new Promise((resolve, reject) => {
            const that = this
            let url = `/questionLibrary/${oid}?`
            url += 'productType=' + productType
            url += '&surveyType=PE'
            url += '&respondentType=' + respondentType

            if (explori && category) {
                url += '&categoryId=' + category
            }
            this.http.get(url)
                .then((response) => {
                    resolve(response)
                })
                .catch((e) => {
                    reject(e)
                })
        })
    }

    getQlist = ({
        recordId = null,
        oid,
        productId,
        productType,
        respondentType,
        surveyType,
        langcode,
        industry,
        cols = 'surveyBuilderReact',
        orderBy,
    }) => {
        return new Promise((resolve, reject) => {
            let qlisturl = "/qlist/getQlists2?"
            qlisturl += "$inlinecount=allpages"
            qlisturl += "&$format=json"
            if (recordId) {
                qlisturl += "&recordId=" + recordId
            } else {
                qlisturl += "&recordId=" + productId
            }
            qlisturl += "&oid=" + oid
            qlisturl += "&productType=" + productType
            qlisturl += "&respondentType=" + respondentType
            qlisturl += "&surveyType=" + surveyType
            qlisturl += "&cols=" + cols
            qlisturl += "&langcode=" + langcode
            qlisturl += `&industry=${industry}`
            if (orderBy) qlisturl += `&orderBy=${orderBy}`
            this.http.get(qlisturl)
            .then((response) => {
                    console.log(JSON.stringify(response, null, 4))
                    resolve(response)
                })
                .catch((e) => {
                    reject(e)
                })
        })
    }

    getQuestions = ({
        category,
        respondentType,
        productType,
        oid = null,
    }) => (
        new Promise((resolve, reject) => {
            let url = `/questionLibrary/${oid}?`
            url += `productType=${productType}`
            url += '&surveyType=PE'
            url += `&respondentType=${respondentType}`
            if (category) url += `&categoryId=${category}`

            this.http.get(url)
                .then((response) => {
                    resolve(response)
                })
                .catch((e) => {
                    reject(e)
                })
        })
    )

    getQuestionCategories = ({
        productType,
        respondentType,
        surveyType,
        clientId = 4,
        isGlobal = 1
    }) => {
        return new Promise((resolve, reject) => {
            let url = "/qlist/getcategories?"
            url += `clientId=${clientId}`
            url += '&cols=categoryId,description'
            url += '&productType=' + productType
            url += '&respondentType=' + respondentType
            url += '&isGlobal=' + isGlobal

            if (surveyType) {
                url += '&surveyType=' + surveyType
            }
    
            this.http.get(url)
                .then((data) => {
                    // console.log(JSON.stringify(data, null, 4))
                    resolve(data)
                })
                .catch((e) => {
                    reject(e)
                })
        })
    }
}